export const hexToRgb = (hex: string): string => {
  // Remove the '#' if it exists
  const cleanedHex = hex.replace('#', '').toLowerCase();

  // Check for valid hex color formats
  const isValidHex = /^([a-f0-9]{3}|[a-f0-9]{6})$/.test(cleanedHex);
  if (!isValidHex) return 'rgb(0, 0, 0)';

  // Expand shorthand hex to full form (e.g., #abc -> #aabbcc)
  const expandedHex =
    cleanedHex.length === 3
      ? cleanedHex
          .split('')
          .map((char) => char + char)
          .join('')
      : cleanedHex;

  // Convert hex to RGB
  const rgbValues = [
    parseInt(expandedHex.slice(0, 2), 16), // Red
    parseInt(expandedHex.slice(2, 4), 16), // Green
    parseInt(expandedHex.slice(4, 6), 16), // Blue
  ];

  return `rgb(${rgbValues.join(', ')})`;
};

export const hexToRgba = (hex: string, alpha: number = 1): string => {
  const rgb = hexToRgb(hex);
  return rgb.replace('rgb', 'rgba').replace(')', `, ${alpha})`);
};
